<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_hr']==1">  

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-2">
                <div class="form-group">
                <label>Month</label>
                <select class="form-control" v-model="month">
                  <option value="1">January</option><option value="2">Febraury</option>
                  <option value="3">March</option><option value="4">April</option>
                  <option value="5">May</option><option value="6">June</option>
                  <option value="7">July</option><option value="8">August</option>
                  <option value="9">September</option><option value="10">October</option>
                  <option value="11">November</option><option value="12">December</option>
                </select>
                </div>
                </div>
                <div class="col-md-2 p-0">
                <div class="form-group">
                <label>Year</label>
                <b-form-select v-model="year" :options="years" class="form-control"></b-form-select>
                </div>
              </div>
              <div class="col-md-3 mt-4">
                <b-button v-b-modal.new-advance variant="primary" @click="FilterData()" ><i class="fas fa-search"></i> Filter</b-button>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(staffmember)="data">
                {{ data.item.staffmember.full_name }} <br>
                <small><b>{{ data.item.staffmember.contact }}</b></small>
              </template>
              <template #cell(salary)="data">
                <b>{{ commas(data.item.staffmember.salary) }}</b>
              </template>
              <template #cell(allowances)="data">{{ commas(data.item.allowances) }}</template>
              <template #cell(advances)="data">{{ commas(data.item.advances) }}</template>
              <template #cell(netpay)="data">{{ commas(data.item.netpay) }}</template>
              <template #cell(balance)="data">{{ commas(data.item.balance) }}</template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.staffmember.id,data.item.balance)" type="button" class="btn-sm btn" variant="primary"> <i class="mdi mdi-square-edit-outline"></i> Pay </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Balances : {{ commas(totalbalances) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="add-payment" centered title="Edit Staff Advance" title-class="font-14" hide-footer>
        <form @submit.prevent="AddPayment">
            <div class="form-group">
            <input v-model="id" type="hidden">
            <label>Staff Member</label>
            <b-form-select v-model="staffmemberid" :options="staffmembers" class="form-control" value-field="id" text-field="full_name"></b-form-select>
            </div>
            <div class="form-group">
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            </div>
            <div class="form-group">
            <label>Month</label>
            <select class="form-control" v-model="month">
              <option value="1">January</option><option value="2">Febraury</option>
              <option value="3">March</option><option value="4">April</option>
              <option value="5">May</option><option value="6">June</option>
              <option value="7">July</option><option value="8">August</option>
              <option value="9">September</option><option value="10">October</option>
              <option value="11">November</option><option value="12">December</option>
            </select>
            </div>
            <div class="form-group">
            <label>Year</label>
            <b-form-select v-model="year" :options="years" class="form-control"></b-form-select>
            </div>
            <div class="form-group">
            <label>Payment Mode</label>
            <b-form-select v-model="payoption" :options="paymentoptions" value-field="id" text-field="name" class="form-control"></b-form-select>
            </div>
            <div class="form-group">
              <label>Pay Date</label>
              <input v-model="paydate" type="date" required class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('add-payment')" >Close</b-button>
                <b-button type="submit" :disabled="btnuser" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
  </div>  
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div>
  </div>

  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { salarypaymentMethods, salarypaymentComputed, paymentoptionMethods, paymentoptionComputed, staffmemberMethods, staffmemberComputed } from "@/state/helpers";

export default {
  page: {
    title: "Salary Details",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Salary Details",
      items: [ {text: "Dashboard",to: "/",}, {text: "Salary Details",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'staffmember', label: 'Staff Member', visible: true },
          { key: 'salary', label: 'Salary', visible: true },
          { key: 'allowances', label: 'Allowances', visible: true },
          { key: 'advances', label: 'Advances', visible: true },
          { key: 'deductions', label: 'Deductions', visible: true },
          { key: 'netpay', label: 'Net Pay', visible: true },
          { key: 'paid', label: 'Paid', visible: true },
          { key: 'balance', label: 'Balance', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      staffmemberid:'',
      amount:'',
      month:new Date().getMonth()+1,
      year:new Date().getFullYear(),
      paydate:new Date().toLocaleDateString('fr-CA'),
      payoption:'',
      fullname:'',
      btnuser:false,
    };
  },
  computed: {
    ...salarypaymentComputed,
      ...paymentoptionComputed,
      ...staffmemberComputed,
    List() { return this.salarypayments.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.salarypayments.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.salarypayments.length>0) { a=false;} else { a=true;} return a },
    totalbalances(){ var total = 0; this.salarypayments.forEach((item)=>{ var item_total = item.balance; total = Number(total)+Number(item_total);}); return total },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSalaryPayment();
    this.fetchPaymentoptions();
    this.fetchStaffMembers();
    this.TotalRows = this.salarypayments.length;
    this.isBusy=false;
    this.payoption = this.paymentoptions.find(option => option.set_default == 1);
  },
  methods: {
    ...salarypaymentMethods,
    ...paymentoptionMethods,
    ...staffmemberMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,staffmember,balance){
      this.id=id;
      this.staffmemberid=staffmember;
      this.amount=balance;
      this.$bvModal.show('add-payment')
    },
    FilterData() {
      this.filterSalaryPayment({month:this.month,year:this.year});
    },
    async AddPayment(){ 
    let formData = new FormData();
    formData.append("staffmemberid", this.staffmemberid);
    formData.append("amount", this.amount);
    formData.append("month", this.month);
    formData.append("year", this.year);
    formData.append("payoption", this.payoption);
    formData.append("paydate", this.paydate);
    let url = "/addsalarypayment";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchSalaryPayment();
        this.$bvModal.hide('add-payment');
        this.staffmemberid="";
        this.amount="";
      }
    });
    },
  },
};
</script>